var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaySolid2Mp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.30566C4 8.40938 4.79722 7.68066 5.77778 7.68066H12.8889C13.8694 7.68066 14.6667 8.40938 14.6667 9.30566V15.8057C14.6667 16.702 13.8694 17.4307 12.8889 17.4307H5.77778C4.79722 17.4307 4 16.702 4 15.8057V9.30566ZM19.5306 8.58965C19.8194 8.73184 20 9.00605 20 9.30566V15.8057C20 16.1053 19.8194 16.3795 19.5306 16.5217C19.2417 16.6639 18.8917 16.6486 18.6167 16.4811L15.95 14.8561L15.5556 14.6148V14.1807V10.9307V10.4965L15.95 10.2553L18.6167 8.63027C18.8889 8.46523 19.2389 8.44746 19.5306 8.58965Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySolid2Mp4);
export default __webpack_public_path__ + "static/media/play-solid 2MP4.5f4059a55eb50db2b3ca1f98bb531d00.svg";
export { ForwardRef as ReactComponent };